import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import companyData from '../../data/data.json';
import { Link } from "react-router-dom";
import Title2Component from '../../components/title/title2Component';

const PolicyView = ({
    data
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Box
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25},
                    pb: {xs: 2, md: 5}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <Title2Component 
                        title={data.title}
                        description={data.updated}
                    />

                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='center'
                        width='100%'
                        spacing={{xs: 3, md: 7}}
                    >
                        {
                            data.content.map((item, index) => {
                                return <PolicyBody 
                                    key={index}
                                    title={item.title}
                                    description={item.description}
                                />
                            })
                        }
                    </Stack>

                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='start'
                        width='100%'
                        pt={{xs: 2, md: 4}}
                        spacing={{xs: 0, md: 0.5}}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {t('company')}
                        </Typography>

                        {/* <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {t('contact.address')}
                        </Typography> */}

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            <Link
                                to={`mailto:${companyData.contact.email}`} 
                                target="_blank"
                                style={{
                                    textDecoration: 'none',
                                    color: theme.palette.text.secondary
                                }}
                            >
                                {companyData.contact.email}
                            </Link>
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            <Link
                                to={companyData.contact.mobile.whatsappLink}
                                target="_blank"
                                style={{
                                    textDecoration: 'none',
                                    color: theme.palette.text.secondary
                                }}
                            >
                                {companyData.contact.mobile.label}
                            </Link>
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
}

export default PolicyView;

const PolicyBody = ({
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                width='100%'
                spacing={{xs: 1.5, md: 3}}
            >  
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 16, lg: 24}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                >
                    {title}
                </Typography>

                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 12, lg: 14}}
                    textAlign="justify"
                    lineHeight={1.5}
                    color={theme.palette.text.secondary}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}